import facebookIcon from "../assets/svg/facebook-icon.svg";
import instagramIcon from "../assets/svg/instagram-icon.svg";
import linkedinIcon from "../assets/svg/linkedin-icon.svg";
import tiktokIcon from "../assets/svg/tiktok-icon.svg";
import youtubeIcon from "../assets/svg/youtube-icon.svg";

export const virtualConsultancySidebarLinks = [
  {
    name: "Ver productos",
    route: "/productos",
    targetBlank: false,
  },
  {
    name: "Solicitar Asesoría",
    route: "/asesoria-virtual",
    targetBlank: false,
  },
  {
    name: "Trabaja con nosotros diseñador",
    route: "/disenador/paso-1",
    targetBlank: false,
  },
  {
    name: "Trabaja con nosotros proveedor",
    route: "/proveedor/paso-1",
    targetBlank: false,
  },
];

export const originTypes = [
  { id: 1, name: "Nacional" },
  { id: 2, name: "Internacional" },
];

export const lightTypes = [
  { id: 1, name: "Cálida" },
  { id: 2, name: "Neutra" },
  { id: 3, name: "Fría" },
];

export const lampTypes = [
  { id: 1, name: "Apliques de pared" },
  { id: 2, name: "Lámparas de techo" },
  { id: 3, name: "Lámparas de mesa" },
  { id: 4, name: "Lámparas de piso" },
  { id: 5, name: "Iluminación especial" },
  { id: 6, name: "Bombillos" },
];

export const editProductTabs = [
  { id: "general", label: "Información General" },
  { id: "measurements", label: " Dimensiones Producto" },
  { id: "packagingMasures", label: "Dimensiones Empaque" },
  { id: "images", label: "Imágenes" },
  { id: "technicalSheet", label: "Ficha Técnica" },
  { id: "complementary", label: "Complementarios" },
];

export const packageTypes = [
  { id: 1, name: "Caja" },
  { id: 2, name: "Sobre" },
];

export const principalImageParagraphs = [
  "Selecciona una imagen principal de alta calidad y con un fondo limpio para resaltar tu producto.",
  "Proporciona múltiples ángulos y detalles para una experiencia de visualización completa.",
  "Mantén un tamaño uniforme y coherente en todas tus imágenes para una presentación profesional y atractiva.",
];

export const ambientImageParagraphs = [
  "Agrega imágenes complementarias para mostrar tu producto en diferentes ambientes y situaciones.",
  "Asegúrate de que las imágenes sean claras y nítidas, y que muestren el producto desde diferentes ángulos y perspectivas.",
  "Agrega máximo 5 imágenes complementarias para mostrar tu producto.",
];

// FILTERS SORT OPTIONS

export const SORT_OPTIONS = [
  { name: "Ninguno", value: "none" },
  { name: "Precio (mayor a menor)", value: "price-asc" },
  { name: "Precio (menor a mayor)", value: "price-desc" },
  { name: "Nombre (ascendente)", value: "name-asc" },
  { name: "Nombre (descendente)", value: "name-desc" },
] as const;

export const socialMediaIcons: SocialMediaIconsMap = {
  1: facebookIcon,
  2: instagramIcon,
  3: youtubeIcon,
  4: linkedinIcon,
  5: tiktokIcon,
};

export const stateStyles = {
  online: {
    borderColor: "green",
    backgroundColor: "green",
    textColor: "text-green-700",
    chipBackgroundColor: "bg-green-200",
  },
  away: {
    borderColor: "yellow",
    backgroundColor: "yellow",
    textColor: "text-yellow-700",
    chipBackgroundColor: "bg-yellow-200",
  },
  offline: {
    borderColor: "border-red-600",
    backgroundColor: "bg-red-500",
    textColor: "text-red-700",
    chipBackgroundColor: "bg-red-200",
  },
};

export const roleRedirects = {
  1: "/productos",
  2: "/productos",
  3: "/proveedor/ventas",
  4: "/lsh/dashboard",
  5: "/admin/dashboard",
  6: "/vendedor/asesorias-activas/lista",
  7: "/empleado/inventario",
};

/* ==== VIDEO TUTORIALS CONSTANTS - SALESPERSON */
export const SALESPERSON_PLATFORM_TUTORIALS: VideoTutorialItem[] = [
  {
    id: 1,
    title: "Video 1",
    url: "https://player.vimeo.com/video/1123932863",
    description: "Descripción del video 1 sobre la plataforma.",
  },
  {
    id: 2,
    title: "Video 2",
    url: "https://player.vimeo.com/video/589486236",
    description: "Descripción del video 2 sobre la plataforma.",
  },
  {
    id: 3,
    title: "Video 3",
    url: "https://player.vimeo.com/video/599119259",
    description: "Descripción del video 3 sobre la plataforma.",
  },
];

export const SALESPERSON_PRODUCT_TUTORIALS: VideoTutorialItem[] = [
  {
    id: 1,
    title: "Video 1",
    url: "https://player.vimeo.com/video/637154880",
    description: "Descripción del video 1 sobre productos.",
  },
  {
    id: 2,
    title: "Video 2",
    url: "https://player.vimeo.com/video/637583900",
    description: "Descripción del video 2 sobre productos.",
  },
  {
    id: 3,
    title: "Video 3",
    url: "https://player.vimeo.com/video/586087409",
    description: "Descripción del video 3 sobre productos.",
  },
  {
    id: 4,
    title: "Video 4",
    url: "https://player.vimeo.com/video/1123932863",
    description: "Descripción del video 4 sobre productos.",
  },
  {
    id: 5,
    title: "Video 5",
    url: "https://player.vimeo.com/video/586912579",
    description: "Descripción del video 5 sobre productos.",
  },
];
